import { expandDecimals, USD_DECIMALS } from "utils/numbers";

export const DEFAULT_MIN_RESIDUAL_GAS_USD_NUMBER = 20;
export const DEFAULT_MIN_RESIDUAL_GAS_USD = expandDecimals(DEFAULT_MIN_RESIDUAL_GAS_USD_NUMBER, USD_DECIMALS);
const DEFAULT_MAX_RESIDUAL_GAS_USD_NUMBER = 40;
export const DEFAULT_MAX_RESIDUAL_GAS_USD = expandDecimals(DEFAULT_MAX_RESIDUAL_GAS_USD_NUMBER, USD_DECIMALS);
export const RESIDUAL_GAS_AMOUNT_MULTIPLIER = 20n;
